export enum QuestionnaireSaveMode {
	IMMEDIATE = 'immediate',
	ON_FINISH = 'on_finish',
}
